export default "__VITE_ASSET__6DWkgP0j__"